module.exports = __webpack_public_path__ + "static/img/icon-mp3.a8e1f61d.svg";